import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-forward-button',
    templateUrl: 'forward-button.component.html'
})
export class ForwardButtonComponent {
    @Input()
    disabled = false;
    @Input()
    isLoading = false;

    showLoader() {
        this.isLoading = true;
    }

    hideLoader() {
        this.isLoading = false;
    }
}